var map = {
	"./demo.svg": "4c6e",
	"./finger.svg": "7bed",
	"./gps.svg": "3377",
	"./log-out.svg": "30fb",
	"./oct.svg": "1913",
	"./password.svg": "2a3d",
	"./phone.svg": "dd82",
	"./qr.svg": "a5e1",
	"./wechat.svg": "80da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";